<template>
  <v-tabs grow class="elevation-5">
    <v-tabs-slider></v-tabs-slider>

    <v-tab href="#tab-ProductTypes"> Ассортимент </v-tab>
    <v-tab-item value="tab-ProductTypes">
      <ProductTypes :organizationUsers="this.organizationUsers" />
    </v-tab-item>

    <v-tab href="#tab-UserPoints"> Пункты доставки </v-tab>
    <v-tab-item value="tab-UserPoints">
      <UserPoints />
    </v-tab-item>
  </v-tabs>
</template>

<script>
const ProductTypes = () => import("./ProductTypes");
const UserPoints = () => import("./UserPoints");

export default {
  props: {
    organizationUsers: Array,
  },
  components: {
    ProductTypes,
    UserPoints,
  },
  computed: {},
  data: () => ({}),
};
</script>
